import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { findIcon } from "../../../../../dashboard/icons";
import { PAGE_MENU } from "../../utils/data";
import {
  useGetProjectDetails,
  useGetSummaryCount,
} from "../../../../../../queries/query-hooks/workspace/emsl-hook";
import { updatePageMenuValues } from "../../utils/commonFunctions";
import CountCardSkeleton from "../../../../../../skeleton/workspace/clirnet/emsl/countCard-skeleton";

const PageMenu = ({ name }) => {
  const navigate = useNavigate();
  const { project_id } = useParams();
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);
  const contentIds = projectDetails?.content
    ?.map((item) => item?.content_id)
    .join(",");
  const payload = {
    start_date: projectDetails?.project_start_date,
    end_date: projectDetails?.project_end_date,
    content_id: contentIds,
  };
  const { data: summaryCount, isLoading: isSummaryCountLoading } =
    useGetSummaryCount(project_id, payload);
  const handleNavigation = (path) => {
    navigate(`/${path}/${project_id}`, { replace: true });
  };
  const formatedPageMenu = updatePageMenuValues(PAGE_MENU, summaryCount);

  return (
    <>
      {!isSummaryCountLoading ? (
        <div className="row">
          {formatedPageMenu?.map((data, index) => (
            <div key={index} className="col-md-3 d-flex flex-wrap">
              <div
                style={{ flex: 1 }}
                className={`card overflow-hidden flex-grow-1 border border-${
                  data.color
                } ${name === data.id ? "" : `border-opacity-10`}`}
                role="button"
                onClick={() => handleNavigation(data.path)}
              >
                <div
                  style={{ flex: 1 }}
                  className="card-body d-flex align-items-center gap-3"
                >
                  <div>
                    <h2
                      className={`mb-0 fw-bold ${
                        name === data.id ? `text-${data.color}` : ""
                      }`}
                    >
                      {data.value}
                    </h2>
                    <p
                      className={`mb-0 ${
                        name === data.id ? `text-${data.color}` : "text-dark"
                      }`}
                    >
                      {data.heading}
                    </p>
                  </div>
                  <div className="ms-auto">
                    <i className={`icon text-${data.color}`}>
                      {findIcon(`${data.icon}`, "solid", "45")}
                    </i>
                  </div>
                </div>
                <div
                  style={{ flex: 1 }}
                  className={`card-body py-2 d-flex bg-soft-${data.color} d-flex text-dark align-items-baseline`}
                >
                  <span className="me-2">
                    <i className={`icon fw-lighter`}>
                      {findIcon("info", "outline", 11)}
                    </i>
                  </span>
                  <p className="mb-0 fs-7 fst-italic poppins-regular">
                    {data.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <CountCardSkeleton />
      )}

      {/* //// */}

      {/* //// */}
    </>
  );
};

export default PageMenu;
